<ng-container *ngIf="hasElements()">
  <p>{{ 'showOnPage' |translate }} :
    <app-dropdown [options]="[60,120,180,240]" [placeholder]="numberOfElements" [activeOption]="activeOption"
                  (selectedItem)="elementsPerPage.emit($event)"></app-dropdown>
  </p>
</ng-container>
